module.exports = __webpack_public_path__ + "91cbbd76e6709e1e97662e26d706cd1e.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/Foto_Manja_Herrmann-8484_klein.jpg
// module id = 462
// module chunks = 0